import { Component, OnInit } from "@angular/core";

import { BaseComponent, UserService, HelperService, WindowService, environment } from "@mypxplat/xplat/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { take } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AddEditSkillComponent } from "../../../modals/add-edit-skill/add-edit-skill.component";

@Component({
  selector: "myp-account-skills",
  templateUrl: "./skills.component.html",
  standalone: false,
})
export class SkillsComponent extends BaseComponent implements OnInit {
  public availableSkills: Array<any>;
  public mySkills: Array<any> = [];
  public loading: boolean;
  public interests: Array<any> = [];
  constructor(
    public userService: UserService,
    public helperService: HelperService,
    private _win: WindowService,
    private _router: Router,
    private _route: ActivatedRoute,
    public appService: AppService,
    private _sanitizer: DomSanitizer,
    private _translate: TranslateService,
    public fbAuth: AngularFireAuth,
    public db: AngularFirestore,
    public router: Router,
    public communityService: WebCommunityService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loadMySkills();
  }

  public skillsByType: any = {};

  loadMySkills() {
    this.loading = true;
    this.skillsByType = {};
    this.communityService.getUserSkills(false, true).subscribe((result) => {
      this.loading = false;
      this.mySkills = result;
      this.mySkills.forEach((skill) => {
        if (!this.skillsByType[skill.type]) {
          this.skillsByType[skill.type] = [];
        }
        this.skillsByType[skill.type].push(skill);
      });
    });
  }

  addSkill() {
    const modalRef = this.appService.showModal(AddEditSkillComponent, { size: "lg" });
    modalRef.componentInstance.skillAdded.pipe(take(1)).subscribe((result) => {
      this.loadMySkills();
    });
  }
}
